/**
 * Якорные ссылки шапки (`#pricing`) на внутренних страницах
 * ведут в никуда. Нормализуем в `/#pricing` — на главной скролл,
 * с /news|/legal/… переход на главную к секции.
 */
export function resolveLandingNavHref(href: string): string {
  const raw = typeof href === "string" ? href.trim() : "";
  if (!raw) return "#";
  if (raw.startsWith("#")) return `/${raw}`;
  return raw;
}
